import {
  GroupPermissionDto,
  useUsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroup,
  useUsersAuthzAPIAdminPermissionsWriteResetGroupPermissions,
  useUsersAuthzAPIPermissionsCatalogGetPermissionsCatalog,
} from '@mi-front/api-clients';
import { Group } from '@mi-front/core';
import { useQueryClient } from '@tanstack/react-query';
import { ActionPermissionsView, PermissionItemComponentProps } from './ActionPermissionsView';
import { GroupPermissionItem } from './GroupPermissionItem';

interface Props {
  readonly group: Group;
}

export function GroupActionPermissionsView(p: Props) {
  const { group } = p;

  const queryClient = useQueryClient();

  // Fetch permissions catalog
  const permissionsCatalogQuery = useUsersAuthzAPIPermissionsCatalogGetPermissionsCatalog();

  // Fetch current group permissions
  const groupPermissionsQuery = useUsersAuthzAPIAdminPermissionsReadGetPermissionsOfGroup(group.id);

  // Create a wrapper component that includes the groupId
  const GroupPermissionItemWrapper = (props: PermissionItemComponentProps<GroupPermissionDto>) => (
    <GroupPermissionItem {...props} groupId={group.id} />
  );

  const resetMutation = useUsersAuthzAPIAdminPermissionsWriteResetGroupPermissions();

  return (
    <ActionPermissionsView
      catalog={permissionsCatalogQuery.data}
      permissions={groupPermissionsQuery.data?.permissions}
      PermissionItemComponent={GroupPermissionItemWrapper}
      isLoading={permissionsCatalogQuery.isLoading || groupPermissionsQuery.isLoading}
      error={permissionsCatalogQuery.error || groupPermissionsQuery.error}
      onReset={async () => {
        await resetMutation.mutateAsync({
          groupId: group.id,
        });

        queryClient.invalidateQueries({
          queryKey: groupPermissionsQuery.queryKey,
        });
      }}
    />
  );
}
